import appConfig from '../../config/appConfig';
import queryParameters from '../../consts/route/queryParameters';
import dateTimeUtils from '../../utils/dateTimeUtils';
import urlUtils from '../../utils/urlUtils';
import cryptoService from '../cryptoService';
import domService from '../domService';
import * as gigyaService from '../gigya/gigyaService';
import iccService from '../icc/iccService';
import dce1Service from '../market/dce1/dce1Service';
import marketTypeService from '../marketTypeService';
import authDataStoreService from './authDataStoreService';

const getInitialCredentials = async () => {
    let spiceToken;
    let username;

    const dataUserToken = appConfig.getDataUserToken();
    const gigyaToken = await gigyaService.getGigyaTokenAsync();
    const isTestLoginEnabled = appConfig.getIsTestLoginEnabled();
    const isDCE1 = marketTypeService.isDCE1();

    if (isTestLoginEnabled) {
        const [spiceTokenFromUrl, usernameFromUrl] = urlUtils.getDataFromUrl(
            queryParameters.DATA_USER_TOKEN,
            queryParameters.USERNAME
        );

        spiceToken = spiceTokenFromUrl;
        username = usernameFromUrl;
    }

    if (!spiceToken && !username) {
        if (process.env.REACT_APP_IS_BUILD_REF === 'true') {
            spiceToken = domService.getDataUserTokenFromRoot();
        } else {
            spiceToken = dataUserToken;
        }
    }

    let decryptedUserToken = spiceToken;
    const isJpMarket = marketTypeService.isJpMarket();
    const isDecryptionRequired = !isDCE1 && !isJpMarket;

    if (isDecryptionRequired) {
        decryptedUserToken = spiceToken ? cryptoService.aesDecrypt(spiceToken) : undefined;
    }

    return {spiceToken: decryptedUserToken, username, gigyaToken};
};

const getAuthToken = async (isAnonymousUserAllowed, isRetry) => {
    try {
        const {accessToken, expirationDate, isAnonymous, isRequestFailed} = authDataStoreService.getAccessTokenData();

        if (isRequestFailed) return null;

        //if token should NOT be anonymous but in state anonymous then retrieve new one
        const isTokenExists = isAnonymousUserAllowed || !isAnonymous ? accessToken : false;
        const isAnonymousRequest = isAnonymousUserAllowed && isAnonymous;

        if (isTokenExists) {
            const isAuthTokenExpired = dateTimeUtils.isExpired(expirationDate);

            if (isAuthTokenExpired) {
                if (process.env.REACT_APP_IS_BUILD_REF === 'true' && marketTypeService.isDCE1()) {
                    await dce1Service.fetchDce1AuthToken(); //update accessToken
                }

                if (isAnonymousRequest) {
                    await iccService.fetchIccToken({isAnonymous: true});
                }

                const {accessToken} = isAnonymousRequest
                    ? await authDataStoreService.getAccessTokenData()
                    : await iccService.refreshIccToken();

                return accessToken;
            } else {
                return accessToken;
            }
        } else if (!isRetry) {
            await iccService.fetchIccToken({isAnonymous: isAnonymousUserAllowed});
            return await getAuthToken(isAnonymousUserAllowed, true);
        }
    } catch (e) {
        return Promise.reject(`getAuthToken error: ${e}`);
    }

    return Promise.reject(`getAuthToken error: return undefined`);
};

export default {
    getAuthToken,
    getInitialCredentials,
};
